import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureGrid from "./components/FeatureGrid";
import ComparisonSection from "./components/ComparisonSection";
import CTASection from "./components/CTASection";
import ArticleHub from "./components/ArticleHub";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <FeatureGrid />
      <ComparisonSection />
      <CTASection />
      <ArticleHub />
      <Testimonials />
      <Footer />
    </main>
  );
}